import { Helmet } from "react-helmet-async";

const SITE_NAME = "Steward Lots";
const BASE_URL = "https://stewardlots.org";
const DEFAULT_IMAGE = "https://customer-assets.emergentagent.com/job_truth-centered/artifacts/4bkl7m0w_B2F741E8-3ED3-4C5F-8567-3D82A405954C.png";

/**
 * SEO component for per-page meta tags
 * @param {string} title - Page title (will be appended with site name)
 * @param {string} description - Meta description for the page
 * @param {string} path - URL path (e.g., "/seller")
 * @param {string} image - Optional custom OG image URL
 */
export function SEO({ title, description, path = "", image = DEFAULT_IMAGE }) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Christ-Led Land Stewardship`;
  const canonicalUrl = `${BASE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={image} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}

export default SEO;
